@if (config.dashboardLoaded) {
  <div class="main-container-body">
    <!--page title and action button top section-->
    <div class="page-title-container d-flex justify-content-end">
      <div class="page-title w-100">
        @if (config && config.name != undefined) {
          <div class="mb-0">
            {{config.name|translate|async}}
            <!--<small>(Beta)</small>-->
          </div>
        }
      </div>
    </div>
    <!--page title and action button top section-->
    <!--page content section-->
    <div class="page-content-section">
      <gridster [options]="options" class="dashboard-item-container mt-2" (drop)="onDrop($event)" style="background-color: white">
        @for (item of dashboardArray; track item; let i = $index) {
          <gridster-item [ngClass]="{'full-screen': (item['fullscreen'] != undefined && item['fullscreen'])}" [item]="item" class="dashboard-item {{item.widg_selector || item.selector}}">
            @if (!editDash && !config.isOnlyMobile && (item['widg_selector']  != undefined && config.allowedFullScreen.indexOf(item['widg_selector']) > -1) ) {
              <div class="position-absolute border rounded border-dark bg-white" style="z-index:1;opacity:0.8;bottom: 0px;right: 0px;">
                @if (item['fullscreen'] == undefined) {
                  <button class="btn btn-icon" title="Make Full Screen" (click)="item['fullscreen'] = true;makeFullScreen(i,true)">
                    <i class="fa fa-expand"></i>
                  </button>
                }
                @if (item['fullscreen'] != undefined && item['fullscreen']) {
                  <button  title="Remove Full Screen" class="btn btn-icon" (click)="item['fullscreen'] = undefined;makeFullScreen(i,false)">
                    <i class="fa fa-times-circle"></i>
                  </button>
                }
              </div>
            }
            <div class="h-100">
              <ng-template #customComponent class=""></ng-template>
            </div>
          </gridster-item>
        }
      </gridster>
    </div>
    <!--page content section-->
  </div>
}

<div dhs-modal></div>